import React, { useEffect, useState } from "react";
import { FormInputField } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "../../hooks";
import { forgotPassword } from "../../redux/actions/ForgetPassword";
import CommonButton from "../../components/Buttons/CommonButton";
import SmallButton from "../../components/Buttons/SmallButton";
import { Logo } from "../../components/Icons";
import Footer from "../../components/Footer";
import LoadingModal from "../../components/Modals/LoadingModal";
import { setPageTitle } from "../../helper/metaDataHelper";
import Slider from "../../components/Login/Slider";
import { urlExists } from "../../helper/urlExists";

const ForgotPassword = () => {
  const forgotEmail = useForm("", "email");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSlider, setShowSlider] = useState(false);
  const company = useSelector((state) => state.ownCompany.company);

  const toggleLoadingModal = (status) => {
    setIsLoading(status);
    setIsModalOpen(status);
  };

  useEffect(() => {
    setPageTitle("Forgot Password");
  }, []);

  const handleForgetPassword = async (e) => {
    e.preventDefault();

    // ✅ Fix validation logic
    if (forgotEmail.validate()) {
      forgotEmail.setError("Please enter a valid email address");
      return;
    }

    toggleLoadingModal(true);

    try {
      const res = await dispatch(forgotPassword({ email: forgotEmail.value }));

      if (res?.status) {
        localStorage.setItem("forgetenEmail", forgotEmail.value);
        localStorage.setItem("allowResetPasswordPage", "true");
        navigate("/reset-password");
      } else {
        forgotEmail.setError(res?.error || "Something went wrong.");
      }
    } catch (error) {
      forgotEmail.setError("An error occurred. Please try again.");
    } finally {
      toggleLoadingModal(false);
    }
  };

  useEffect(() => {
    const checkSlider = async () => {
      const enabled = process.env.REACT_APP_SHOW_SLIDER === "true";

      if (!enabled || !company?.login_page_image) {
        setShowSlider(false);
        return;
      }

      const exists = await urlExists(company.login_page_image);

      setShowSlider(exists);
    };

    checkSlider();
  }, [company?.login_page_image]);

  const SHOW_SLIDER = process.env.REACT_APP_SHOW_SLIDER === "true" && showSlider;

  return (
    <main>
      <div className="max-w-[1024px] mx-auto px-4 py-8 min-h-dvh flex flex-col justify-center">
        <div
          className={`flex flex-col ${
            SHOW_SLIDER
              ? "sm:flex-row justify-center gap-3"
              : "items-center justify-center"
          }`}
        >
          {/* First section */}
          <div
            className={`w-full ${
              SHOW_SLIDER ? "md:w-[572px] sm:flex-grow" : "max-w-[384px]"
            } mb-6 sm:mb-0 space-y-4 flex flex-col items-center`}
          >
            <div className="flex flex-col items-center justify-between w-full max-w-[384px] h-[684px]">
              <Logo className="auth-logo" />

              <div className="flex flex-col items-start justify-center w-full">
                <SmallButton href="/signin" text="Back" back />

                <p className="auth-page-title">Forgot password</p>

                <form
                  onSubmit={handleForgetPassword}
                  className="w-full pt-[52px] space-y-4"
                >
                  <FormInputField
                    id="email"
                    label="Email"
                    type="email"
                    placeholder="Enter your email address"
                    onChange={forgotEmail.onChange}
                    {...forgotEmail}
                  />
                  <CommonButton
                    type="submit"
                    disabled={!forgotEmail.value}
                    onClick={handleForgetPassword}
                  >
                    Email me recovery OTP
                  </CommonButton>

                  <div className="flex items-center justify-center pt-4 space-x-2">
                    <p className="common-lable">Trouble logging in?</p>
                    {/* Optional: Add help link */}
                    {/* <SmallButton text="Get Help" /> */}
                  </div>
                </form>
              </div>
            <Footer />
            </div>
          </div>

          {/* Right Section (Slider) */}
          {SHOW_SLIDER && <Slider />}
        </div>
      </div>
      <LoadingModal
        isLoading={isLoading}
        setisLoading={setIsLoading}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </main>
  );
};

export default ForgotPassword;
